export default __webpack_public_path__ + "static/media/portPopUp.e3c293de.svg";